
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { pilesUpdPasswordBatch } from "@/api/api-basic";
@Component
export default class PiModelAdd extends Vue {
  private type = "1";
  private modalShow = false;
  private loading = false;
  private showErr = false;
  private password = "";
  private idList: object[] = [];
  private reg = /^[0-9]{4,8}$/;
  public open(selectList: objAny = []) {
    this.showErr = false;
    this.type == "1";
    this.password = "";
    this.modalShow = true;
    this.idList = selectList.map(item => item.pilePkId);
  }
  public passwordChange() {
    this.showErr = !this.reg.test(this.password);
  }
  public typeChange() {
    if (this.type == "1") {
      if (this.password) {
        this.showErr = !this.reg.test(this.password);
      } else {
        this.showErr = false;
      }
    } else {
      this.showErr = false;
    }
  }

  public closeModal() {
    this.modalShow = false;
  }
  async handleSubmit() {
    this.showErr = this.type == "1" && !this.reg.test(this.password);
    if (this.showErr) return;
    this.loading = true;
    const res = await pilesUpdPasswordBatch({
      deviceSns: this.idList,
      password: this.type == "1" ? this.password : ""
    });
    this.loading = false;
    if (res.status == this.$config.apiStatus) {
      this.modalShow = false;
      this.$Modal.success({
        content: this.$t("equipmentList.pwdSucc") + ""
      });
    } else {
      this.$Message.error(res.msg);
    }
  }
}
